export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-foursquare-b9f05b505192091fdf3078b05c677d78.svg";